@if ((context.page.index | realPageNumber) > 0) {
    <div [ngClass]="position" class="dropdown sharing-dropdown">
        <button [attr.id]="'dropdownMenu' + context.page.id" aria-expanded="true" aria-haspopup="true"
                class="btn btn-default dropdown-toggle"
                data-bs-toggle="dropdown"
                (click)="handleClosingTools($event)"
                type="button">
            <i class="fa fa-share"></i>
        </button>
        <div [attr.aria-labelledby]="'dropdownMenu' + context.page.id" [class.dropdown-menu-end]="position === 'right'"
             class="dropdown-menu">
            <app-sharing-options (platformLinkCopied)="onPlatformLinkCopied($event)"
                                 [sharingContext]="context"></app-sharing-options>
        </div>
    </div>
}